import * as Logos from '@atlaskit/logo';
import Lozenge from '@atlaskit/lozenge';
import { B200, B400, DN10A, N700 } from '@atlaskit/theme/colors';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import { ProductKey } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import React from 'react';
import { LogoOptionsType } from '../../../../../model/side-information-component';
import { messages } from '../messages';

enum Product {
  DEVOPS = 'devops'
}

export function Logo({ product, layout, logoColor }: LogoOptionsType) {
  const productkey = product.product;
  const textColor = layout === 'devops' ? N700 : DN10A;

  const productContent =
    product.productContent && product.productContent.length
      ? product.productContent[0]
      : null;

  const Logostyle = {
    iconColor: B200,
    iconGradientStart: B400,
    iconGradientStop: B200,
    size: 'xlarge',
    textColor
  };

  if (logoColor) {
    Logostyle.iconColor = logoColor;
    Logostyle.textColor = logoColor;
  }
  if (layout === Product.DEVOPS && product.product === Product.DEVOPS) {
    return (
      <DevopsLogoContainer key={'devops'}>
        <DevopsLogoWrapper>
          <Logos.AtlassianIcon
            className="atl-logo"
            key={layout}
            {...Logostyle}
          />
          <LogoText>DevOps {messages.devopsLogo.defaultMessage}</LogoText>
          <LozengeContainer>
            <Lozenge appearance="success">
              <SanitizedFormattedHtmlMessage {...messages.devopsEarlyAccess} />
            </Lozenge>
          </LozengeContainer>
        </DevopsLogoWrapper>
        <SubheadingText>
          <SanitizedFormattedHtmlMessage {...messages.devopsLogoSubHeader} />
        </SubheadingText>
      </DevopsLogoContainer>
    );
  }

  // for team central, get the logo from magnolia
  if (
    (productkey === ProductKey.TEAM_CENTRAL &&
      !!productContent.productLogoUrl) ||
    (productkey === ProductKey.JIRA_PRODUCT_DISCOVERY &&
      !!productContent.productLogoUrl)
  ) {
    return <CMSLogo src={productContent.productLogoUrl} />;
  }

  if (productContent && productContent.atlasKitLogoName) {
    // Check for CMS driven product logo
    // Try and get Atlaskit Logo from product data
    if (productContent.atlasKitLogoName) {
      const allLogos = { ...Logos };
      const ProductLogoClass = allLogos[productContent.atlasKitLogoName];
      if (!!ProductLogoClass) {
        return <ProductLogoClass key={productkey} {...Logostyle} />;
      }
    }
  }

  switch (productkey) {
    case 'com.atlassian.bitbucket':
      return <Logos.BitbucketLogo key={productkey} {...Logostyle} />;
    case 'confluence.ondemand':
      return <Logos.ConfluenceLogo key={productkey} {...Logostyle} />;
    case 'jira-core.ondemand':
      return <Logos.JiraWorkManagementLogo key={productkey} {...Logostyle} />;
    case 'jira-servicedesk.ondemand':
      return (
        <Logos.JiraServiceManagementLogo key={productkey} {...Logostyle} />
      );
    case 'jira-software.ondemand':
      return <Logos.JiraLogo key={productkey} {...Logostyle} />;
    case 'jira-workmanagement.ondemand':
      return <Logos.JiraWorkManagementLogo key={productkey} {...Logostyle} />;
    case 'opsgenie':
      return <Logos.OpsGenieLogo key={productkey} {...Logostyle} />;
    case 'statuspage':
      return <Logos.StatuspageLogo key={productkey} {...Logostyle} />;
    case 'trello':
      return <Logos.TrelloLogo key={productkey} {...Logostyle} />;
    case 'compass':
      return <Logos.CompassLogo key={productkey} {...Logostyle} />;
    default:
      return productContent && productContent.productName ? (
        <h2 style={{ color: textColor }}>${productContent.productName}</h2>
      ) : (
        <Logos.AtlassianLogo key={productkey} {...Logostyle} />
      );
  }
}

const DevopsLogoWrapper = styled.div`
  display: flex;
  line-height: 66px;
`;
const DevopsLogoContainer = styled.div`
  .atl-logo {
    width: 58px;
    height: 55px;
    max-height: none;
    display: inline-block;
    margin: 8px 0;

    @media only screen and (max-width: 800px) {
      margin: 0px 0;
    }
  }
`;

const LogoText = styled.div`
  @media only screen and (max-width: 800px) {
    display: none;
  }
  white-space: nowrap;
  font-size: 44px;
  font-weight: 600;
  margin-top: 2px;
`;
const SubheadingText = styled.div`
  @media only screen and (max-width: 800px) {
    display: none;
  }
  font-family: Charlie Display;
  font-weight: 400;
  font-size: 34px;
  span {
    margin: 0 !important;
    line-height: 45px;
  }
`;
const LozengeContainer = styled.div`
  @media only screen and (max-width: 800px) {
    display: none;
  }
  margin: 26px 12px 0px 12px;
  span {
    span {
      margin: 0px;
    }
  }
`;

const CMSLogo = styled.img`
  height: 48px;
`;
